<div class="col-md-12">
  <div class="row" style="padding-top: 15px">
    <div class="col-md-12 mt-2">
      <h4 class="mb-0" p>{{ 'ReceivedShares' | translate }}</h4>
    </div>
  </div>
  <hr />
  <h5 class="mb-3">{{ 'SitesShares' | translate }}</h5>
  <div class="form-group flex-align-items">
    <label style="position: relative; top: 5px; margin-right: 10px">{{ 'Search' | translate }}</label>
    <input
      #search
      class="form-control"
      type="text"
      [(ngModel)]="searchTerm"
      style="max-width: 400px"
      placeholder="{{ 'PlaceholderSearchShares' | translate }}"
    />
  </div>
  <div>
    <ngx-datatable
      [messages]="{ emptyMessage: translate.instant('NoData') }"
      [columnMode]="'force'"
      class="data-table table-responsive mb-3"
      [limit]="20"
      [rows]="shares.content"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="40"
    >
      <ngx-datatable-column [minWidth]="350" [maxWidth]="350" [resizeable]="false" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Site' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="siteShareRowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ row.site.domainName }}">{{ row.site.domainName }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [minWidth]="200" [resizeable]="false" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Emitter' | translate }}
        </ng-template>
        <ng-template
          [typedTemplate]="siteShareRowType"
          class="flex-align-items"
          let-row="row"
          ngx-datatable-cell-template
        >
          <span>{{ row.sender.name }}</span
          >&nbsp;
          <app-badge-organization [code]="row.sender.code"></app-badge-organization>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [minWidth]="100" [maxWidth]="100" [resizeable]="false" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Type' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="siteShareRowType" let-row="row" ngx-datatable-cell-template>
          <label-share-role [role]="row.role" />
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [maxWidth]="85" [resizeable]="false" [sortable]="false" cellClass="actions">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Actions' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="siteShareRowType" let-row="row" ngx-datatable-cell-template>
          <i
            (click)="showModalDeleteShare(row)"
            class="icofont icofont-ui-delete"
            title="{{ 'Annuler' | translate }}"
          ></i>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-curPage="index" let-pageSize="size">
          <small class="ogo-ngx-datatable-footer"
            >Total : {{ shares.totalElements }}
            {{
              shares.totalElements > 1
                ? ('MesPartages' | translate | lowercase) + 's'
                : ('MesPartages' | translate | lowercase)
            }}
          </small>
          <datatable-pager
            [pagerLeftArrowIcon]="pager.PREV"
            [pagerRightArrowIcon]="pager.NEXT"
            [pagerPreviousIcon]="pager.FIRST"
            [pagerNextIcon]="pager.LAST"
            [page]="shares.page + 1"
            [size]="shares.size"
            [count]="shares.totalElements"
            (change)="changeSharesPage($event)"
          >
          </datatable-pager>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
    <hr />
    <h5 class="mt-4 mb-3">{{ 'ClustersDelegation' | translate }}</h5>
    <ngx-datatable
      [messages]="{ emptyMessage: translate.instant('NoData') }"
      [columnMode]="'force'"
      class="data-table table-responsive mb-3"
      [rows]="delegations.content"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="40"
    >
      <ngx-datatable-column [resizeable]="false" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'ClusterName' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="delegationRowType" let-row="row" ngx-datatable-cell-template>
          <span title="{{ row.cluster.name }}">{{ row.cluster.name }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [minWidth]="120" [maxWidth]="120" [resizeable]="false" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Type' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="delegationRowType" let-row="row" ngx-datatable-cell-template>
          <label-delegation-role [role]="row.role" />
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [maxWidth]="85" [resizeable]="false" [sortable]="false" cellClass="actions">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Actions' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="delegationRowType" let-row="row" ngx-datatable-cell-template>
          <i
            (click)="showModalDeleteDelegation(row)"
            class="icofont icofont-ui-delete"
            title="{{ 'supprimer' | translate }}"
          ></i>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-curPage="index" let-pageSize="size">
          <small class="ogo-ngx-datatable-footer"
            >Total : {{ delegations.totalElements }}
            {{
              delegations.totalElements > 1
                ? ('MesPartages' | translate | lowercase) + 's'
                : ('MesPartages' | translate | lowercase)
            }}
          </small>
          <datatable-pager
            [pagerLeftArrowIcon]="pager.PREV"
            [pagerRightArrowIcon]="pager.NEXT"
            [pagerPreviousIcon]="pager.FIRST"
            [pagerNextIcon]="pager.LAST"
            [page]="delegations.page + 1"
            [size]="delegations.size"
            [count]="delegations.totalElements"
            (change)="changeDelegationsPage($event)"
          >
          </datatable-pager>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
